export default "/images/bd179fe1a20ee36d47f61a67ec52db2b.avif";